import { render, staticRenderFns } from "./SolutionTypeList.vue?vue&type=template&id=6a1aa06e&scoped=true"
import script from "./SolutionTypeList.vue?vue&type=script&lang=js"
export * from "./SolutionTypeList.vue?vue&type=script&lang=js"
import style0 from "./SolutionTypeList.vue?vue&type=style&index=0&id=6a1aa06e&prod&lang=scss&module=true&scoped=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "6a1aa06e",
  null
  
)

export default component.exports